import { render, staticRenderFns } from "./LifeMartLandingPage.vue?vue&type=template&id=9c27994c"
import script from "./LifeMartLandingPage.vue?vue&type=script&lang=js"
export * from "./LifeMartLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports